import api from "../index";

export const GetPaymentTypeApi = () => api.post("get-payment-types");
export const EditPaymentTypeApi = (data) => api.post("update-payment-type", data);
export const AddPaymentTypeApi = (data) => api.post("create-payment-type", data);
export const DeletePaymentTypeApi = (data) => api.post("delete-payment-type", data);
export const ChangePaymentTypeStatusApi = (data) => api.post("change-payment-type-status", data);



